/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeQueryDTO
 */
export interface AttributeQueryDTO {
    /**
     * Filter attribute paths, if null api returns all attributes
     * @type {Array<string>}
     * @memberof AttributeQueryDTO
     */
    attributePathsFilter?: Array<string>;
}

/**
 * Check if a given object implements the AttributeQueryDTO interface.
 */
export function instanceOfAttributeQueryDTO(value: object): value is AttributeQueryDTO {
    return true;
}

export function AttributeQueryDTOFromJSON(json: any): AttributeQueryDTO {
    return AttributeQueryDTOFromJSONTyped(json, false);
}

export function AttributeQueryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeQueryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributePathsFilter': json['attributePathsFilter'] == null ? undefined : json['attributePathsFilter'],
    };
}

export function AttributeQueryDTOToJSON(value?: AttributeQueryDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributePathsFilter': value['attributePathsFilter'],
    };
}

